import { useRef } from "react";
import { jsPDF } from "jspdf";
import { FaPrint } from "react-icons/fa"; // Using FontAwesome for the print icon
// import Image from "next/image"

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
};

export default function PurchaseOrder({ orderData }) {
  const formattedDate = formatDate(orderData.createdAt);
  const componentRef = useRef();

  // Function to generate and download PDF
  const handleDownloadPDF = () => {
    window.print();
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white" ref={componentRef}>
      {/* Header */}
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 relative">
            {/* <Image
              src="/placeholder.svg"
              alt="Company Logo"
              width={64}
              height={64}
              className="object-contain"
            /> */}
          </div>
          <div className="text-right">
            <button
              onClick={handleDownloadPDF}
              className="p-2 text-blue-500 rounded-full flex items-center gap-2 hover:bg-gray-200 print:hidden"
            >
              <FaPrint />
              <span className="text-sm">Download PDF</span>
            </button>
          </div>
        </div>
        <div className="text-right">
          <h1 className="text-3xl font-serif mb-2">Estimate By Client</h1>
          <p className="text-sm text-gray-700">
            <span className="font-semibold">Estimate #:</span> {orderData.purchaseNo}
          </p>
          <p className="text-sm text-gray-700">
            <span className="font-semibold">DATE:</span> {formattedDate}
          </p>
        </div>
      </div>

      {/* Client Information */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold bg-[#fef2e7] px-4 py-2 mb-4 rounded-md shadow-sm">CLIENT INFORMATION</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <p className="font-semibold mb-1">Name:</p>
            <p className="text-sm">{orderData.clientDetails.firmName}</p>
            <p className="text-xs text-gray-600">Attn: {orderData.clientDetails.contactPerson}</p>
          </div>
          <div>
            <p className="font-semibold mb-1">Contact:</p>
            <p className="text-sm">Phone: {orderData.clientDetails.mobileNo}</p>
            <p className="text-sm">Email: {orderData.clientDetails.email}</p>
          </div>
        </div>
      </div>

      {/* Order Information */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold bg-[#fef2e7] px-4 py-2 mb-4 rounded-md shadow-sm">ORDER INFORMATION</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-gray-50">
                <th className="border p-2 text-left">PRODUCT NAME</th>
                <th className="border p-2 text-left">ITEM #</th>
                <th className="border p-2 text-left">ITEM Image</th>
                <th className="border p-2 text-right">PRICE</th>
                <th className="border p-2 text-center">QTY</th>
                <th className="border p-2 text-right">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {orderData.items.map((item, index) => (
                <tr key={index}>
                  <td className="border px-2 py-1">{item.itemName}</td>
                  <td className="border px-2 py-1">{item.itemCode}</td>
                  <td className="border px-2 py-1"><img src={item.itemImage} alt="Item Image"  width={40}
                    height={40}
                    className="object-contain" /></td>
                  <td className="border px-2 py-1 text-right">₹{item.itemPrice.toFixed(2)}</td>
                  <td className="border px-2 py-1 text-center">{item.itemQuantity}</td>
                  <td className="border px-2 py-1 text-right">₹{item.itemTotal.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Payment Information */}
      <div className="grid grid-cols-2 gap-6 mb-6">
        <div>
          <h2 className="text-lg font-semibold bg-[#fef2e7] px-4 py-2 mb-4 rounded-md shadow-sm">SHIPPING INFO</h2>
          <div className="space-y-2">
            <p>
              <span className="font-semibold">Warehouse:</span> {orderData.warehouseName}
            </p>
            <p>
              <span className="font-semibold">Method:</span> Standard Shipping
            </p>
            {/* <p>
              <span className="font-semibold">Delivery Time:</span> 3-5 Business Days
            </p> */}
          </div>
        </div>
        <div>
          <h2 className="text-lg font-semibold bg-[#fef2e7] px-4 py-2 mb-4 rounded-md shadow-sm">PAYMENT INFO</h2>
          <div className="space-y-2">
            <div className="flex justify-between font-bold">
              <span>Total Amount:</span>
              <span>₹{orderData.totalPurchaseCost.toFixed(2)}</span>
            </div>
            {/* <div className="flex justify-between">
              <span>Tax (18%):</span>
              <span>₹{(orderData.totalPurchaseCost * 0.18).toFixed(2)}</span>
            </div>
            <div className="flex justify-between font-bold">
              <span>TOTAL:</span>
              <span>₹{(orderData.totalPurchaseCost * 1.18).toFixed(2)}</span>
            </div> */}
          </div>
        </div>
      </div>

      {/* Notes */}
      <div>
        <h2 className="text-lg font-semibold bg-[#fef2e7] px-4 py-2 mb-4 rounded-md shadow-sm">NOTES</h2>
        <p className="text-sm text-gray-600 border p-4 rounded-md">
          The amount of the Purchase Order is the agreed fixed price and shall not be exceeded without advanced written
          consent.
        </p>
      </div>
    </div>
  );
}
